/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import BezierShapeRenderer from './BezierShapeRenderer';

/**
 * Class to render a EllipseShape. The given points are rendered using
 * a bezier curve.
 *
 * @class EllipseShapeRenderer
 * @extends BezierShapeRenderer
 * @constructor
 */
class EllipseShapeRenderer extends BezierShapeRenderer {}

export default EllipseShapeRenderer;



// WEBPACK FOOTER //
// ../jsg-ui/src/graph/view/shapes/EllipseShapeRenderer.js